export const couriers = {
    'DPD': {
        displayName: 'DPD',
        icon: 'van',
        RmfName: 'Van',
    },
    'UKMail': {
        displayName: 'DPD', // currently all UKMail deliveries are handelled by DPD for FF
        icon: 'van',
        RmfName: 'Van',
    },
    'Global': {
        displayName: 'a Freddie’s van',
        icon: 'van',
        RmfName: 'Van',
    },
    'Global Heston': {
        displayName: 'a Freddie’s van',
        icon: 'van',
        RmfName: 'Van',
    },
    'Global Tamworth': {
        displayName: 'a Freddie’s van',
        icon: 'van',
        RmfName: 'Van',
    },
    'Global Bristol': {
        displayName: 'a Freddie’s van',
        icon: 'van',
        RmfName: 'Van',
    },
    'Global Bicester': {
        displayName: 'a Freddie’s van',
        icon: 'van',
        RmfName: 'Van',
    },
    'Global Cambridge': {
        displayName: 'a Freddie’s van',
        icon: 'van',
        RmfName: 'Van',
    },
    'FF Vans': {
        displayName: 'a Freddie’s van',
        icon: 'van',
        RmfName: 'Van',
    },
    'FF Vans SE': {
        displayName: 'a Freddie’s van',
        icon: 'van',
        RmfName: 'Van',
    },
    'FF Vans Heston': {
        displayName: 'a Freddie’s van',
        icon: 'van',
        RmfName: 'Van',
    },
    'FF Vans SW': {
        displayName: 'a Freddie’s van',
        icon: 'van',
        RmfName: 'Van',
    },
    'Zedify': {
        displayName: 'a Freddie’s electric bike',
        icon: 'bike',
        RmfName: 'Bike',
    },
    'Pedal Me': {
        displayName: 'a Freddie’s electric bike',
        icon: 'bike',
        RmfName: 'Bike',
    },
    'FF Bikes': {
        displayName: 'a Freddie’s electric bike',
        icon: 'bike',
        RmfName: 'Bike',
    },
    'FF Bikes SE': {
        displayName: 'a Freddie’s electric bike',
        icon: 'bike',
        RmfName: 'Bike',
    },
    'FF Bikes SW': {
        displayName: 'a Freddie’s electric bike',
        icon: 'bike',
        RmfName: 'Bike',
    },
    'FF Bikes - SE Bikes': {
        displayName: 'a Freddie’s electric bike',
        icon: 'bike',
        RmfName: 'Bike',
    },
};
